import { render, staticRenderFns } from "./ownerDetailReceipt.vue?vue&type=template&id=326a914f"
import script from "./ownerDetailReceipt.vue?vue&type=script&lang=js"
export * from "./ownerDetailReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports